import { createSlice } from '@reduxjs/toolkit';
import { instance } from 'utils/axios';

import { useSnackbar } from 'notistack';

const initialState = {
  allwebsites: [],
  servers: [],
  websites: [],
  noOfRecords: 0,
  website: {},
  isFetchWebsitesPending: false,
  isFetchWebsitePending: false,
  isAddUpdateWebsitePending: false,
  isAddUpdateWebsiteSuccess: false,
  isAddUpdateWebsiteError: null,
  isDeleteWebsiteSuccess: false,
  deleteWebsiteError: null
};

const slice = createSlice({
  name: 'website',
  initialState,
  reducers: {
    fetchAllServers(state, action) {
      state.servers = action.payload.data;
    },
    fetchAllWebsites(state, action) {
      state.allwebsites = action.payload.items;
      state.noOfRecords = action.payload.count;
    },
    fetchWebsites(state, action) {
      state.websites = action.payload.items;
      state.noOfRecords = action.payload.count;
    },
    fetchWebsite(state, action) {
      state.website = action.payload;
    },
    setFetchWebsitesPending(state, action) {
      state.isFetchWebsitesPending = action.payload;
    },
    setFetchWebsitePending(state, action) {
      state.isFetchWebsitePending = action.payload;
    },
    setAddUpdateWebsitesPending(state, action) {
      state.isAddUpdateWebsitePending = action.payload;
    },
    setAddUpdateWebsitesSuccess(state, action) {
      state.isAddUpdateWebsiteSuccess = action.payload;
    },
    setAddUpdateWebsitesError(state, action) {
      state.isAddUpdateWebsiteError = action.payload;
    },
    setDeleteWebsiteSuccess(state, action) {
      state.isDeleteWebsiteSuccess = action.payload;
    },
    setDeleteError(state, action) {
      state.deleteWebsiteError = action.payload;
    }
  }
});

export const { reducer } = slice;

export const setAddUpdateWebsitesErrorBank = () => async (dispatch) => {
  dispatch(slice.actions.setAddUpdateWebsitesError(null));
};

export const fetchWebsites =
  (pageNo = 1, perPage = 10, keyword = '', order = '', desc = false) =>
  async (dispatch) => {
    dispatch(slice.actions.setDeleteWebsiteSuccess(false));
    dispatch(slice.actions.setDeleteError(null));
    dispatch(slice.actions.setFetchWebsitesPending(true));
    dispatch(slice.actions.fetchWebsites({ items: [], count: -1 }));

    const response = await instance
      .post(`/websites/getAll/${pageNo}/${perPage}/search=${keyword}&order=${order}${desc ? ' desc' : ''}`, {})
      .catch((error) => {
        console.log(error);
        if (error.response) {
          // CustomSnackbar('error', err.response.data.data);
        }
      });
    if (response) {
      dispatch(slice.actions.fetchWebsites(response.data.data));
    }
    dispatch(slice.actions.setFetchWebsitesPending(false));
  };

export const fetchAllWebsites = () => async (dispatch) => {
  dispatch(slice.actions.fetchWebsites({ items: [], count: -1 }));

  const response = await instance.post('websites/get', {});
  if (response) {
    dispatch(
      slice.actions.fetchAllWebsites({
        items: response.data.data,
        count: response.data.data.length
      })
    );
  }
};

export const fetchWebsite = (id) => async (dispatch) => {
  dispatch(slice.actions.setFetchWebsitePending(true));

  const response = await instance.post(`websites/get/${id}`, {}).catch((err) => {
    if (err.response) {
      // CustomSnackbar('error', err.response.data.data);
    }
  });
  dispatch(slice.actions.setFetchWebsitePending(false));
  if (response) {
    dispatch(slice.actions.fetchWebsite(response.data.data));
  }
};

export const addWebsite = (postData) => async (dispatch) => {
  dispatch(slice.actions.setAddUpdateWebsitesPending(true));
  dispatch(slice.actions.setAddUpdateWebsitesSuccess(false));
  dispatch(slice.actions.setAddUpdateWebsitesError(null));

  const response = await instance.post('websites/create', postData).catch((err) => {
    if (err.response) {
      dispatch(slice.actions.setAddUpdateWebsitesError(err.response.data.data));
    }
  });
  dispatch(slice.actions.setAddUpdateWebsitesPending(false));
  if (response) {
    dispatch(slice.actions.setAddUpdateWebsitesSuccess(true));
    return response;
  }
};

export const updateWebsite = (id, postData) => async (dispatch) => {
  dispatch(slice.actions.setAddUpdateWebsitesPending(true));
  dispatch(slice.actions.setAddUpdateWebsitesSuccess(false));
  dispatch(slice.actions.setAddUpdateWebsitesError(null));

  const response = await instance.post(`websites/update/${id}`, postData).catch((err) => {
    if (err.response) {
      dispatch(slice.actions.setAddUpdateWebsitesError(err.response.data.data));
    }
  });
  dispatch(slice.actions.setAddUpdateWebsitesPending(false));
  if (response) {
    dispatch(slice.actions.setAddUpdateWebsitesSuccess(true));
    return response;
  }
};

export const deleteWebsites =
  (postData, pageNo, perPage, keyword = '') =>
  async (dispatch) => {
    dispatch(slice.actions.setDeleteWebsiteSuccess(false));
    dispatch(slice.actions.setAddUpdateWebsitesPending(true));
    const response = await instance.post('websites/delete', postData).catch((err) => {
      if (err.response) {
        dispatch(slice.actions.setDeleteError(err.response.data.data));
      }
    });
    dispatch(slice.actions.setAddUpdateWebsitesPending(false));
    if (response) {
      dispatch(slice.actions.setDeleteWebsiteSuccess(true));
      dispatch(fetchWebsites(pageNo, perPage, keyword));
    }
  };

// servers api
export const fetchAllServers = () => async (dispatch) => {
  const response = await instance.post('servers/get', {}).catch((err) => {});
  if (response) {
    dispatch(
      slice.actions.fetchAllServers({
        data: response.data.data
      })
    );
  }
};

export default slice;
